import styled from "styled-components";

export const ModalStyled = styled.div`
    padding: 2rem;
    border-radius: 0.25rem;
    background: ${({ theme }) => theme.content.background};
`;
